import script from "./ChatPublicReportPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPublicReportPage.vue?vue&type=script&setup=true&lang=js"

import "./ChatPublicReportPage.vue?vue&type=style&index=0&id=079418f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-079418f7"]])

export default __exports__